import type { ModuleRowColumn } from 'types/capi/article';

// Tailwind's md breakpoint: max-md:hidden hides an element below 768px.
const MOBILE_MAX_WIDTH_PX = 767;

// A row column is hidden on mobile when the editor hid it, when it has nothing
// in it, or when every module in it is hidden — ModuleRow renders it
// max-md:hidden in all three cases, so nothing inside it has a box on a phone.
export function isColumnHiddenOnMobile(column: ModuleRowColumn) {
  if (column.mobile_hidden) return true;
  if (!column.modules?.length) return true;

  return column.modules.every((m) => m.mobile_hidden);
}

// Whether a module inside a row is hidden on mobile: its column is, or it is
// itself. Only modules inside rows honour mobile_hidden; a top-level module
// renders on every viewport whatever was authored.
export function isRowModuleHiddenOnMobile(
  column: ModuleRowColumn,
  module: ModuleRowColumn['modules'][number]
) {
  return isColumnHiddenOnMobile(column) || !!module.mobile_hidden;
}

// The viewport the page is being read in, for deciding what rendered with a
// box. False on the server, where there is no viewport to ask.
export function isMobileViewport(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;

  return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH_PX}px)`).matches;
}
